import { APP_API_IDENTIFIER } from '@mews-commander/constants';
import { normalizeRequestData, normalizeResponseData } from '@mews-commander/legacy-data-structures';
import { CaseStyle, DateTimePrecision } from '@mews/enums';
import { ResponseError, sendRequest, type } from '@mews/framework';

const getValue = (value: $TSFixMe) => (typeof value === 'function' ? value() : value);

export default function BaseApiComponent(apiType: $TSFixMe, params: $TSFixMe) {
    const {
        application = '',
        baseUrl = '',
        webSocketUrl = '',
        versionHash = 'Unknown',
        getCurrentProfileId,
        getScopeIdByProfileId,
        getCurrentEnterpriseId,
    } = params;

    let requestAbortController = new window.AbortController();

    return type.create(apiType, {
        async request(url: string, data = {}, options = {}) {
            return sendRequest(
                `${getValue(baseUrl)}${url}`,
                {
                    signal: requestAbortController.signal,
                    customHeaders: {
                        'X-Accept-Casing': CaseStyle.Camel,
                        'X-Accept-DateTime-Precision': DateTimePrecision.Milliseconds,
                    },
                    credentials: 'include',
                    ...options,
                },
                // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type '{ [x: string]: any; profileId: any; }'.
                normalizeRequestData(extendData(data))
            );
        },

        getWebSocketUrl() {
            return `${getValue(webSocketUrl)}?ScopeId=${getScopeIdByProfileId({ profileId: getCurrentProfileId() })}`;
        },

        abortCurrentRequests() {
            requestAbortController.abort();

            // reset instance of signal to enable subsequent request calls
            requestAbortController = new window.AbortController();
        },

        normalizeWebSocketResponse(data: $TSFixMe) {
            let obj;
            try {
                obj = JSON.parse(data);
            } catch (ex) {
                throw new ResponseError(`Unexpected message from websocket: ${data}`);
            }
            return normalizeResponseData(obj);
        },
    });
    // @ts-expect-error $TSFixMeError: Binding element 'dataProfileId' implicitly has an 'any' type.
    function extendData({ profileId: dataProfileId, ...data }) {
        const profileId = dataProfileId || getCurrentProfileId();

        return {
            profileId,
            ...(data.enterpriseIds ? {} : { enterpriseId: getCurrentEnterpriseId() }),
            application: getValue(application),
            client: `${APP_API_IDENTIFIER} ${getValue(versionHash)}`,
            ...data,
        };
    }
}
